import { ReactElement, useEffect, useState } from "react";
import { Layout, Row, Col, Card, Statistic, Breadcrumb, message, BackTop, Space, Button, Table } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import { EyeOutlined, ShareAltOutlined, PlusOutlined, UserOutlined, ScheduleTwoTone, ShoppingTwoTone, SafetyCertificateTwoTone, CarryOutTwoTone } from "@ant-design/icons";
import { ViewState, EditingState, IntegratedEditing, IntegratedGrouping, GroupingState } from "@devexpress/dx-react-scheduler";
import {
  Scheduler,
  DayView,
  Toolbar,
  DateNavigator,
  Appointments,
  TodayButton,
  AppointmentTooltip,
  CurrentTimeIndicator,
  Resources,
  GroupingPanel,
} from "@devexpress/dx-react-scheduler-material-ui";
import { Chart, SplineSeries, BarSeries, ArgumentAxis, ValueAxis, Tooltip, } from "@devexpress/dx-react-chart-material-ui";
import { ArgumentScale, ValueScale, Animation, EventTracker } from "@devexpress/dx-react-chart";
import { scaleBand } from "@devexpress/dx-chart-core";
import firebase from "firebase/app";
import "firebase/firestore";
import Clipboard from "react-clipboard.js";
import CountUp from 'react-countup';
import { ToolbarWithLoading } from "../../components/Scheduler/ToolbarWithLoading";
import { BookingTooltipHeader } from "../../components/Scheduler/BookingTooltipHeader";
import { BookingTooltipContent } from "../../components/Scheduler/BookingTooltipContent";
import api from "../../redux/api/axiosInstance";
import { SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";
import { BreadCrumbWrapper } from "../../components/GlobalStyles";
import { getClubState, getAuthState } from "../../redux/selectors";


const { Content } = Layout;

const statisticsValueStyle = {
  fontWeight: 700,
  fontFamily: "Raleway",
  display: "flex",
  justifyContent: "center",
  fontSize: 40,
  marginTop: 10
}

export function ClubDashboard(): ReactElement {
  const history = useHistory();
  const [currentDate, setCurrentDate] = useState<any>(new Date());
  const [loading, setLoading] = useState<boolean>(false);
  const [branches, setBranches] = useState<any[]>([]);
  const [courtCount, setCourtCount] = useState<number>(0);
  const [bookingOfMonth, setBookingOfMonth] = useState<any[]>([]);
  const [bookingOfWeek, setBookingOfWeek] = useState<any[]>([]);
  const [chartMode, setChartMode] = useState("month");
  const [todayBookings, setTodayBookings] = useState(0);
  const [weekBookings, setWeekBookings] = useState(0);
  const [monthBookings, setMonthBookings] = useState(0);
  const [orders, setOrders] = useState<any[]>([]);
  const [bookingHistory, setBookingHistory] = useState<any[]>([]);
  const [priorityUsers, setPriorityUsers] = useState<any[]>([])
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { clubId } = useParams<{ clubId: string }>();
  const club = useSelector(getClubState).clubs.find(c => c.firestoreRef === clubId);


  const getOrders = async () => {
    await firebase.firestore().collection("request_item").get()
      .then(async (res) => {
        const requestItems = await Promise.all(res.docs.map(async (doc) => {
          const itemData = doc.data();
          const buyerSnapshot = await firebase.firestore().collection("users").doc(itemData.buyer).get();
          const buyerData = buyerSnapshot.data();

          const productSnapshot = await firebase.firestore().collection("products").doc(itemData.product_id).get();
          const productData = productSnapshot.data();

          return { ...itemData, createdDate: moment(itemData.makedate.seconds * 1000).format("MMM DD, YYYY H:mm A"), productName: productData?.name, buyerInfo: buyerData?.fullName };
        }));
        setOrders(origin => {
          return requestItems;
        });
      })
      .catch(e => {
        console.log(e);
      })
  }

  const getStatistics = async () => {
    const today = moment();
    const year = today.format("YYYY");
    const month = today.format("M");
    const mBranches:any[] = [];
    let totalCourts = 0;
    const daysInMonth = moment().daysInMonth();
    const startOfWeek = moment().startOf('week');
    const endOfWeek = moment().endOf('week');
    const startOfSearchDate = `${year}-${month}-01`;


    const bookingCountOfMonth:any[] = [];
    for (let i = 0; i < daysInMonth; i+=1) {
      bookingCountOfMonth[i] = { date: i + 1, value: 0 };
    }
    const clubSnapshot = await firebase.firestore().collection("clubs").doc(clubId).get();
    const clubData = clubSnapshot.data();
    const branchSnapshots = await firebase.firestore().collection("branches").where("club", "==", clubId).orderBy("location", "asc").get();
    try {
      await Promise.all(
        branchSnapshots.docs.map(async (doc) => {
          const bookingData:any[] = [];
          const gBranches:any[] = [];
          const gCourts:any[] = [];
          const branch = doc.data();
          gBranches.push({
            text: branch.location,
            id: doc.id
          });
          const courtSnapshots = await firebase.firestore().collection("courts").where("branchId", "==", doc.id).orderBy("name", "asc").get();
          totalCourts += courtSnapshots.size;
          courtSnapshots.docs.forEach((cDoc) => {
            const data = cDoc.data();
            gCourts.push({
              text: data.name,
              id: cDoc.id
            });
          });
          const bookingSnapshots = await
            firebase.firestore()
              .collection("bookings")
              .where("branchId", "==", doc.id)
              .where("date", ">=", startOfSearchDate)
              .get();

          await Promise.all(
            bookingSnapshots.docs.map(async (bDoc) => {
              const data = bDoc.data();
              if (data.status === "cancelled") return;
              const courtSnapshot = await firebase.firestore().collection("courts").doc(data.courtId).get();
              const courtData = courtSnapshot.data();
              const bookingDate = moment(`${data.date}T00:00:00`);
              // if (bookingDate.format("YYYY") === year && bookingDate.format("M") === month)
              bookingCountOfMonth[parseInt(bookingDate.format("D"), 10) - 1].value += 1;

              const book = {
                // title: `${userData.fullName}`,
                title: data.user ? data.user.fullName : "Unknown User",
                startDate: moment(`${data.date} ${data.start}`).format("YYYY-MM-DDTHH:mm:ss"),
                endDate: moment(`${data.date} ${data.start}`)
                  .add(data.period, "m")
                  .format("YYYY-MM-DDTHH:mm:ss"),
                id: data.bookingId,
                ...data,
                branch: branch.location,
                club: clubData,
                court: courtData,
                user: data.user || {}
              }
              if (data.userId !== "") {
                const userSnapshot = await firebase.firestore().collection("users").doc(data.userId).get();
                const userData = userSnapshot.data();
                book.user = userData;
                book.title = userData?.fullName;
              }

              bookingData.push(book);

            })
          );
          const gResource = [
            {
              fieldName: "courtId",
              title: "Court",
              instances: gCourts,
            }
          ];
          const gGrouping = [
            { resourceName: "courtId" },
          ];

          mBranches.push({
            gResource,
            gGrouping,
            bookingData,
            branch: {
              ...branch,
              courtsCount: gCourts.length
            },
          });
        })
      );
        const sortedBranches = mBranches.sort((a: any, b: any) => b.branch.courtsCount - a.branch.courtsCount);
      setBranches(sortedBranches);
    setCourtCount(totalCourts);
      
    } catch (e) {
      console.log("error:", JSON.stringify(e));
      dispatch({ type: RESET_LOADING_STATE });
      return;
    }

    let mBookingOfWeek = mBranches.map(b => {
      return b.bookingData.map((bd:any) => {
        // if(bd.date)
        const startWeekString = startOfWeek.format("YYYY-MM-DD");
        const endWeekString = endOfWeek.format("YYYY-MM-DD");
        if (bd.date >= startWeekString && bd.date <= endWeekString) return bd;
        return null;
      })
    });

    mBookingOfWeek = mBookingOfWeek.flat().filter(b => b !== null);
    const bookingCountOfWeek = mBookingOfWeek.length;

    // Get booking history of this club
    const historySnapshots = await firebase.firestore().collection("booking_history").doc(clubId).collection("history").limit(10).orderBy("createdAt", "desc").get();
    const historyOfClub = historySnapshots.docs.map(h => h.data());
    setBookingHistory(historyOfClub);

    const priorityList = clubData?.priority ? clubData.priority : [];

    const mPriorityUsers = await Promise.all(
      priorityList.map(async (uid:string) => {
        const userSnapshot = await firebase.firestore().collection('users').doc(uid).get();
        return userSnapshot.data();
      })
    )
    setPriorityUsers(mPriorityUsers);

    setBookingOfMonth(bookingCountOfMonth);
    setBookingOfWeek(mBookingOfWeek);
    const countOfMonth = bookingCountOfMonth.reduce((acc: number, current: any) => acc + current.value, 0);
    const countOfWeek = bookingCountOfWeek;
    const countOfToday = bookingCountOfMonth[parseInt(moment().format("D"), 10) - 1].value;
    setTodayBookings(countOfToday);
    setWeekBookings(countOfWeek);
    setMonthBookings(countOfMonth);
    dispatch({ type: RESET_LOADING_STATE });
  }

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    dispatch({ type: SET_LOADING_STATE });
    if (clubId === "" || clubId === null || clubId === undefined) return;
    // api.post("getStatistics", { club: clubId })
    //   .then(response => {
    //     const mBranches = response.data.branches.sort((a: any, b: any) => b.branch.courtsCount - a.branch.courtsCount);
    //     setBranches(mBranches);
    //     setCourtCount(response.data.totalCourts);
    //     setBookingOfMonth(response.data.bookingCountOfMonth);
    //     setBookingOfWeek(response.data.bookingCountOfWeek);
    //     setBookingHistory(response.data.historyOfClub);
    //     const countOfMonth = response.data.bookingCountOfMonth.reduce((acc: number, current: any) => acc + current.value, 0);
    //     const countOfWeek = response.data.bookingCountOfWeek;
    //     const countOfToday = response.data.bookingCountOfMonth[parseInt(moment().format("D"), 10) - 1].value;
    //     setTodayBookings(countOfToday);
    //     setWeekBookings(countOfWeek);
    //     setMonthBookings(countOfMonth);
    //     setPriorityUsers(response.data.priorityUsers);
    //     dispatch({ type: RESET_LOADING_STATE });
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     dispatch({ type: RESET_LOADING_STATE });
    //   });
    getStatistics();
  }, []);

  const cancelBooking = (bookingId: string) => {
    setLoading(true);
    api.post("/cancel_booking", { bookingId })
      .then(() => { setLoading(false); })
      .catch(e => {
        setLoading(false);
      })
  };
  const onCommitChanges = (data: any) => {
    const { added, changed, deleted } = data;
    if (deleted !== undefined) {
      cancelBooking(deleted);
    }
  };
  const onViewOrder = (record: any) => {
    history.push(`/orders/${record?.request_id}`);
  }

  const orderColumn: any = [
    {
      title: t("table.request_id"),
      dataIndex: "request_id",
      key: "request_id",
    },
    {
      title: t("table.name"),
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: t("table.quantity"),
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: t("table.request_date"),
      dataIndex: "createdDate",
      key: "createdDate",
    },
    {
      title: t("table.buyer"),
      dataIndex: "buyerInfo",
      key: "buyerInfo",
    },
    {
      title: t("common.action"),
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <Button shape="circle" type="primary" onClick={() => onViewOrder(record)}><EyeOutlined /></Button>
        </Space>
      ),
    },
  ];
  const renderCalendar = (data: any): ReactElement => {
    const { branch, bookingData, gResource, gGrouping } = data;
    const courtCountOfBranch = gResource[0].instances.length;
    if (courtCountOfBranch === 0) return (<></>);
    const courtSpan = courtCountOfBranch > 8 ? 3 : Math.ceil(24 / courtCount);
    return (
      <Col xs={24} sm={courtCountOfBranch * courtSpan} key={branch.branchId}>
        <Paper className="booking-history-view">
          <div className="dashboard-branch-title">{branch.location}</div>
          <Scheduler data={bookingData}>
            <ViewState
              currentDate={currentDate}
              onCurrentDateChange={(date) => setCurrentDate(date)}
            />
            <EditingState onCommitChanges={onCommitChanges} />
            <IntegratedEditing />
            <DayView
              startDayHour={0}
              endDayHour={24}
              cellDuration={60}
              intervalCount={1}
              name={branch.location}
            />
            <Toolbar
              {...(loading ? { rootComponent: ToolbarWithLoading } : null)}
            />
            <DateNavigator />
            <TodayButton />
            <Appointments />
            <Resources
              data={gResource}
              mainResourceName="courtId"
            />
            <GroupingState grouping={gGrouping} />
            <IntegratedGrouping />
            <GroupingPanel />
            <AppointmentTooltip
              headerComponent={BookingTooltipHeader}
              contentComponent={(d) => BookingTooltipContent(d, true)}
              // showDeleteButton
              showCloseButton
            />
            <CurrentTimeIndicator shadePreviousCells shadePreviousAppointments />
          </Scheduler>
        </Paper>
      </Col>
    );
  }
  const onSuccessCopyClubLink = () => {
    message.success("Club link copied!");
  };

  // For history
  const historyColumn = [
    {
      title: "Booking #",
      dataIndex: "bid",
      key: "bookingId"
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "Timestamp",
      key: "timestamp",
      render: (record: any) => (
        // eslint-disable-next-line
        <span>{moment(record.createdAt.seconds * 1000).format("MMM DD, YYYY H:mm A")}</span>
      )
    },
  ]


  return (
    <Content>
      <BackTop />
      <BreadCrumbWrapper>
        <Breadcrumb style={{ fontSize: 18 }}>
          <Breadcrumb.Item>{t("club.clubs")}</Breadcrumb.Item>
          <Breadcrumb.Item>{club?.name}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("club.dashboard")}</Breadcrumb.Item>

        </Breadcrumb>
      </BreadCrumbWrapper>
      <Row gutter={16} style={{ marginTop: 20 }}>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <div className="statistics-card-container">
              <div>
                <h3 className="statistics-card-value"><CountUp end={todayBookings} duration={todayBookings * 0.1} /></h3>
                <h5 className="statistics-card-label">Bookings Of Today</h5>
              </div>
              <div className="statistics-card-icon-container">
                <CarryOutTwoTone twoToneColor="#4e74e1" style={{ fontSize: 42 }} />
              </div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <div className="statistics-card-container">
              <div>
                <h3 className="statistics-card-value"><CountUp end={weekBookings} duration={weekBookings * 0.05} /></h3>
                <h5 className="statistics-card-label">Bookings Of Week</h5>
              </div>
              <div className="statistics-card-icon-container">
                <ScheduleTwoTone twoToneColor="#FFB319" style={{ fontSize: 42 }} />
              </div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <div className="statistics-card-container">
              <div>
                <h3 className="statistics-card-value"><CountUp end={monthBookings} duration={monthBookings * 0.05} /></h3>
                <h5 className="statistics-card-label">Bookings Of Month</h5>
              </div>
              <div className="statistics-card-icon-container">
                <SafetyCertificateTwoTone twoToneColor="green" style={{ fontSize: 42, color: "#4e74e1" }} />
              </div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="dashboard-statistics-card">
            <div className="statistics-card-container">
              <div>
                <h3 className="statistics-card-value"><CountUp end={orders.length} duration={orders.length * 0.05} /></h3>
                <h5 className="statistics-card-label">Order Requests</h5>
              </div>
              <div className="statistics-card-icon-container">
                <ShoppingTwoTone twoToneColor="#A45D5D" style={{ fontSize: 42 }} />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 20 }}>
        {!loading && branches.map((b) => renderCalendar(b))}
      </Row>

      {bookingOfMonth &&
        <Paper style={{ marginTop: 20 }}>
          {/* <div style={{ width : "100%", padding: 10, textAlign:"right"}}>
            <Button type={chartMode === "month" ? "primary" : "default"} onClick={() => setChartMode("month")}>Month</Button>
            <Button type={chartMode === "week" ? "primary" : "default"} onClick={() => setChartMode("week")}>Week</Button>
          </div> */}
          <Chart
            data={chartMode === "month" ? bookingOfMonth : bookingOfWeek}
          >
            <ArgumentScale factory={scaleBand} />
            <ValueScale name="value" />
            <ArgumentAxis />
            <ValueAxis scaleName="value" showGrid={false} showLine showTicks />
            <BarSeries
              valueField="value"
              argumentField='date'
            />
            <SplineSeries
              valueField='value'
              argumentField='date'
              name='Date'
              scaleName="value"
            />
            <Animation />
            <EventTracker />
            <Tooltip />
          </Chart>

        </Paper>
      }
      {/* Booking History */}
      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={24}>
          <Paper style={{ padding: 10 }}>
            <h3>Recent Bookings</h3>
            <Table dataSource={bookingHistory} pagination={false} columns={historyColumn} />
          </Paper>
        </Col>
      </Row>

      <Clipboard
        data-clipboard-text={`${window.location.protocol}//${window.location.host}/share/${clubId}`}
        onSuccess={onSuccessCopyClubLink}
        className="ant-btn ant-btn-primary cm-dashboard-share-button"
      >
        <ShareAltOutlined />
      </Clipboard>
    </Content>
  );
}
